var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{attrs:{"hide-input":"","multiple":"","prepend-icon":"mdi-paperclip"},on:{"change":_vm.addAttachment},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }